/**
 * Virus / malware scan hook — replace with async call to your AV pipeline (e.g. ClamAV, cloud scanner).
 * Must run server-side for production; this stub keeps the client contract ready.
 */
export async function virusScanPlaceholder(_file: File): Promise<{ ok: true } | { ok: false; reason: string }> {
  return { ok: true };
}
